import React from 'react';
import Icon from './UI/Icon';
import './Hero.css';

const Hero = () => {
  return (
    <header id="home" className="hero-section">
      {/* Background Glowing Ambient Accents */}
      <div className="hero-glow glow-1 animate-float"></div>
      <div className="hero-glow glow-2 animate-float" style={{ animationDelay: '-3s' }}></div>

      <div className="container hero-container">
        <div className="grid-2 hero-grid">
          {/* Hero Left Content */}
          <div className="hero-content animate-fade-in-up">
            <div className="hero-badge">
              <Icon name="award" size={16} className="badge-icon" />
              <span>12+ Years Professional Experience</span>
            </div>
            
            <h1 className="hero-title">
              Active Joint <br />
              <span className="text-gradient">Physiotherapy</span> & <br />
              Sports Rehabilitation
            </h1>
            
            <p className="hero-description">
              We go beyond routine therapy. Our mission is to help you live a pain-free, confident, and active life through personalized and holistic care tailored for children, adults, and seniors.
            </p>

            <div className="hero-ctas">
              <a 
                href="https://wa.me/918826265224?text=Hello%20Dr.%20Anil%20Kumar,%20I%20would%20like%20to%20book%20a%20physiotherapy%20consultation." 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-primary btn-lg pulse-button"
              >
                <Icon name="calendar" size={20} />
                <span>Book Appointment</span>
              </a>
              <a href="#specializations" className="btn btn-outline btn-lg">
                <span>Our Services</span>
                <Icon name="chevronright" size={18} />
              </a>
            </div>

            {/* Quick trust metrics */}
            <div className="hero-metrics">
              <div className="metric-item">
                <span className="metric-num">12+</span>
                <span className="metric-label">Years Exp</span>
              </div>
              <div className="metric-item">
                <span className="metric-num">2000+</span>
                <span className="metric-label">Treatments</span>
              </div>
              <div className="metric-item">
                <span className="metric-num">100%</span>
                <span className="metric-label">Safe & Gentle</span>
              </div>
              <div className="metric-item">
                <span className="metric-num">2000+</span>
                <span className="metric-label">Happy Patients</span>
              </div>
            </div>
          </div>

          {/* Hero Right Visual Column */}
          <div className="hero-visual animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="image-frame-container">
              {/* Backlight elements */}
              <div className="frame-backlight"></div>
              
              <div className="main-image-wrapper">
                <img 
                  src="/assets/doctor_clinic.jpeg" 
                  alt="Dr. Anil Kumar in his physiotherapy clinic" 
                  className="hero-main-image"
                />
              </div>

              {/* Float Experience Badge */}
              <div className="floating-badge glass-card animate-float">
                <div className="floating-badge-icon">
                  <Icon name="activity" size={22} />
                </div>
                <div className="floating-badge-text">
                  <span className="badge-title">Active Joint Care</span>
                  <span className="badge-sub">Holistic Recovery</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Feature Badges */}
        <div className="hero-features-bar glass-card animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <div className="feature-bar-item">
            <Icon name="shield" className="feature-bar-icon" size={22} />
            <div className="feature-bar-text">
              <h4>Gentle & Safe Care</h4>
              <p>For children, adults, seniors</p>
            </div>
          </div>
          
          <div className="feature-bar-item">
            <Icon name="checkcircle" className="feature-bar-icon" size={22} />
            <div className="feature-bar-text">
              <h4>Home Exercise Plans</h4>
              <p>Custom programs for recovery</p>
            </div>
          </div>

          <div className="feature-bar-item">
            <Icon name="heart" className="feature-bar-icon" size={22} />
            <div className="feature-bar-text">
              <h4>Welcoming Space</h4>
              <p>Affordable, patient-friendly</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
